import {Component, Vue} from "vue-property-decorator";
import {icons, Icon} from "~/components/icon";

@Component
export class PartnerNav extends Vue {
  render(){
    return (
      <nav class="nav">
        <router-link to="/" >
          <Icon icon={icons.allUsers} />
          <span>Comptes clients</span>
        </router-link>

        <router-link to={{ name: 'partners_notifications' }}>
          <Icon icon={icons.notification} />
          <span>Notifications</span>
        </router-link>
      </nav>
    );
  }
}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-74575b08/partner-nav.tsx" });